<template>
  <svg :width="width"
       :height="height"
       viewBox="0 0 12 16"
       fill="none"
       role="presentation"
       @click="$emit('click')"
       xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3C0 1.34315 1.34315 0 3 0H9C10.6569 0 12 1.34315 12 3V16L6 12L0 16V3Z" :fill="disabled ? disabledStateColor : iconColor"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>